import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * Handles the redirect from https://auth.emergentagent.com/
 * The URL fragment carries #session_id=<one-time token>.
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS,
 * THIS BREAKS THE AUTH.
 */
const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { refreshFromBackend } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || '';
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    (async () => {
      if (!sessionId) {
        navigate('/', { replace: true });
        return;
      }
      try {
        const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/session`, {
          method: 'POST',
          headers: { 'X-Session-ID': sessionId },
          credentials: 'include',
        });
        if (!res.ok) throw new Error('session-exchange-failed');
        await res.json();
      } catch { /* still fall through so we don't strand the user */ }

      // Refresh AuthProvider state so the app immediately knows the user.
      await refreshFromBackend();

      // Clear the fragment from history and land on the home page.
      window.history.replaceState(null, '', '/');
      navigate('/', { replace: true });
    })();
  }, [location, navigate, refreshFromBackend]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0a0a0f]">
      <div className="text-white/70 text-sm" data-testid="auth-callback-loader">
        Connexion en cours…
      </div>
    </div>
  );
};

export default AuthCallback;
